import {
  GET_GOLF_BOOKING_BY_ID,
  GET_GOLF_BOOKING_BY_ID_SUCCESS,
  GET_GOLF_BOOKING_BY_ID_ERROR,
} from "./../../actionType.js";

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetGolfBookingById = (state = initialState, action) => {
  switch (action.type) {
    case GET_GOLF_BOOKING_BY_ID:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_GOLF_BOOKING_BY_ID_SUCCESS:
      state = {
        ...state,
        data: action.payload?.data,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_GOLF_BOOKING_BY_ID_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetGolfBookingById;
